module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_323713546_L-919ac47e23c5221a73c0a4beeeb75227.jpg";